import { useTranslation } from "react-i18next";
import { Box, ListItemText, List } from "@material-ui/core";
import { Collapse, Grid, IconButton, ListItem, SnackbarContent } from "@material-ui/core";

// Icons
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import { Close, CheckCircleOutline } from "@material-ui/icons";

const SucessMessages = ({
	openSnacSuccess,
	setOpenSnacSuccess,
	messages,
	sucessAlertTitle,
	classes,
	closeSucessMessages,
}) => {
	const { t } = useTranslation();
	const isMultiple = messages?.length > 1;

	const handleSuccessList = () => {
		setOpenSnacSuccess(!openSnacSuccess);
	};

	return (
		<SnackbarContent
			className={classes.successMessage}
			role="status"
			aria-live="polite"
			message={
				<Grid>
					<Grid>
						<List className={`${classes.sucessList} p-0 m-0`}>
							<ListItem className={`${classes.justify} p-1 m-0`}>
								<span className="d-flex flex-column w-100 align-items-start">
									<Box className="d-flex px-2 w-100">
										<CheckCircleOutline className={classes.successIcon} />
										<ListItemText primary={sucessAlertTitle} className={classes.successList_2} />
										<Grid>
											<span className={classes.justify}>
												<IconButton
													aria-label={t("alerts.dismissSuccess")}
													onClick={closeSucessMessages}
													className="m-0 p-1"
												>
													<Close className={classes.successIcon} />
												</IconButton>
											</span>
										</Grid>
									</Box>
									<Box className="d-flex px-2 w-100">
										<ListItemText
											primary={
												isMultiple
													? sucessAlertTitle
													: messages.map((message) => t(message) || message).join(", ")
											}
											className={classes.successList_3}
										/>
										<Grid></Grid>
									</Box>
								</span>
							</ListItem>
							{isMultiple && (
								<ListItem onClick={handleSuccessList} className={classes.justify}>
									<span className="d-flex flex-column mt-1 w-100 align-items-end">
										{openSnacSuccess ? <ExpandLess /> : <ExpandMore />}
										<span className="d-flex flex-column w-100 align-items-start">
											{messages?.map((message) => (
												<Collapse in={openSnacSuccess} timeout="auto" unmountOnExit>
													<Box className="d-flex py-2">
														<CheckCircleOutline className={`${classes.successIcon} mx-2`} />
														{t(message) || message}
														<br />
													</Box>
												</Collapse>
											))}
										</span>
									</span>
								</ListItem>
							)}
						</List>
					</Grid>
				</Grid>
			}
		/>
	);
};

export default SucessMessages;
